import type { JsonValue } from 'type-fest';

import { prepareAndMakeRequest } from '@frontend/api';

export default {
  get: (quoteId: string): Promise<JsonValue> =>
    prepareAndMakeRequest.get<JsonValue>(`/quotes/${quoteId}/digital_views/`),
};
